/* tslint:disable */

declare var Object: any;
export interface SFAttCorrectionRequestInterface {
  "id"?: number;
}

export class SFAttCorrectionRequest implements SFAttCorrectionRequestInterface {
  "id": number;
  constructor(data?: SFAttCorrectionRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttCorrectionRequest`.
   */
  public static getModelName() {
    return "SFAttCorrectionRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttCorrectionRequest for dynamic purposes.
  **/
  public static factory(data: SFAttCorrectionRequestInterface): SFAttCorrectionRequest{
    return new SFAttCorrectionRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttCorrectionRequest',
      plural: 'SFAttCorrectionRequests',
      path: 'SFAttCorrectionRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttCorrectionRequest.ts